/**
 * Onde a linha entra quando o botão do mouse é solto (SPEC-20260923-2331).
 *
 * Sem rede nem React: é a conta que decide a ordem final, e é onde mora o erro
 * clássico de um-a-mais. Arrastar uma linha PARA BAIXO dentro da mesma lista é
 * o caso que engana — tirar a linha da posição antiga desloca todos os índices
 * seguintes, então calcular o alvo antes de remover dá um lugar errado.
 */

export type LinhaComId = { id: string }

/**
 * A ordem do checklist de destino com a linha movida no lugar.
 *
 * `antes` diz de que lado do alvo ela entra — é o traço que a tela desenha
 * conforme o ponteiro passa da metade da linha.
 */
export function ordemAoSoltar(
  destino: readonly LinhaComId[],
  movidaId: string,
  alvoId: string,
  antes: boolean,
): string[] {
  // remover PRIMEIRO, procurar o alvo DEPOIS: assim o índice já está na escala
  // certa e não precisa de correção conforme a direção do arraste
  const sem = destino.filter((i) => i.id !== movidaId).map((i) => i.id)
  const at = sem.indexOf(alvoId)
  if (at < 0) return sem
  sem.splice(antes ? at : at + 1, 0, movidaId)
  return sem
}

/** Soltar no vazio da lista: vai para o fim. */
export function ordemNoFim(destino: readonly LinhaComId[], movidaId: string): string[] {
  return [...destino.filter((i) => i.id !== movidaId).map((i) => i.id), movidaId]
}

/** Já está exatamente onde cairia: não vale uma ida ao servidor. */
export function jaEstaNoFim(destino: readonly LinhaComId[], movidaId: string): boolean {
  return destino.at(-1)?.id === movidaId
}
